<template>
  <div class="charts" :class="{nodata_img:nodata}"></div>
</template>
<script>
import echarts from './index'
import debounce from 'lodash/debounce'
import { addListener, removeListener } from 'resize-detector'
import { loadingOpts } from './defaultOption'
import {} from './util'
export default {
  props: {
    nodata: {
      type: Boolean,
      default: false
    },
    initOptions: {
      type: Object,
      default: () => {},
    },
    options: Object,
  },
  data() {
    return {
      chart: null,
    }
  },
  created() {
    this.initOptionsWatcher()
  },
  mounted() {
    if (this.options) {
      
      this.init()
    }
  },
  methods: {
    initOptionsWatcher() {
      if (this.__unwatchOptions) {
        this.__unwatchOptions()
        this.__unwatchOptions = null
      }

      this.__unwatchOptions = this.$watch(
        'options',
        (val, oldVal) => {
          if (!this.chart && val) {
            this.init()
          } else {
            this.chart.setOption(val, val !== oldVal)
          }
        },
        { deep: true }
      )
    },
    delegateMethod(name, ...args) {
      if (!this.chart) {
        this.init()
      }
      return this.chart[name](...args)
    },
    mergeOptions(options, notMerge) {
      if (!this.chart) {
        this.init(options)
      } else {
        this.delegateMethod('setOption', options, notMerge)
      }
    },
    init(options) {
      if (this.chart) {
        return
      }
      let chart = echarts.init(this.$el, 'tdTheme') //, { renderer: 'svg' })
      chart.setOption(options || this.options || {}, true)
      this.lastArea = this.getArea()
      this.__resizeHandler = debounce(
        () => {
          if (this.lastArea === 0) {
            this.mergeOptions({}, true)
            this.resize()
            this.mergeOptions(this.options || {}, true)
          } else {
            this.resize()
          }
          this.lastArea = this.getArea()
        },
        500,
        { leading: true }
      )
      addListener(this.$el, this.__resizeHandler)
      this.chart = chart
      if (!this.chart.showLoading) {
        this.showLoading()
      }
    },
    getArea() {
      return this.$el.offsetWidth * this.$el.offsetHeight
    },
    showLoading(type, options) {
      this.delegateMethod('showLoading', type || loadingOpts, options)
    },
    hideLoading() {
      this.chart && this.delegateMethod('hideLoading')
    },
    resize(options) {
      this.delegateMethod('resize', options)
    },
    dispose() {
      this.delegateMethod('dispose')
    },
    destroy() {
      removeListener(this.$el, this.__resizeHandler)
      this.dispose()
      this.chart = null
    },
  },
  beforeDestroy() {
    if (this.chart) {
      this.destroy()
    }
  },
}
</script>
<style lang="less">
// .charts {
//   width: 100%;
//   height: 100%;
// }
.charts{
    width: 100%;
    height: 100%;
    &.nodata_img{
      background: url(../../assets/img/noData.svg) no-repeat center center;
      div{
        opacity: 0;
      }
    }
}
.en_us .charts{
    &.nodata_img{
      background: url(../../assets/img/noData_en.svg) no-repeat center center;
      div{
        opacity: 0;
      }
    }
}
</style>
